import React from 'react';
import ProjectCreateContainer from '../../../Componant/Project/ProjectCreate/index.jsx';

const ProjectCreate = () => {
  return (
    <div className='page-body'>
      <ProjectCreateContainer />
    </div>
  );
};

export default ProjectCreate;
